import { Box, Link, Stack, Typography } from "@mui/material";

const ClientItem = ({ client }) => {
  const clientAddr = (`${client.PostalCode || ''}　${client.Pref || ''}${client.Adr || ''}`).trim();
  const clientTel = `${client.Tel || ''}`;
  return (
    <Box sx={{ border: "1px solid #ccc", padding: 1, borderRadius: 1, marginTop: 1 }}>
      <Typography sx={{ fontSize: "0.9rem", fontWeight: "bold", color: "#009527" }} >{client.ClientName}</Typography>
      {!!clientAddr && (<Typography sx={{ fontSize: "0.8rem" }}>{`〒${clientAddr}`}</Typography>)}
      {!!clientTel && (<Typography sx={{ fontSize: "0.8rem" }}>{`TEL：`}<Link href={`tel:${clientTel}`} rel="noopener" >{clientTel}</Link></Typography>)}
      <Stack direction="row" justifyContent={"end"}>
        <Link href={`/client/${client.ClientID}`} rel="noopener">{">>>"}</Link>
      </Stack>
    </Box>
  );
}
export default ClientItem;